module.exports = __webpack_public_path__ + "static/media/refresh.14bf33d1.svg";